export enum AttachmentType {
  MembershipDisability = 1,
  MembershipIDCard,
  EventCoverPhoto,
  EventMainPhoto,
  ProductCoverPhoto,
  ProductMainPhoto,
  ReservationReceipt,
  MembershipNationalID,
}
